export default "__VITE_ASSET__ngmQtnvP__"